import {
    WithId,
} from 'app/types/common.types'
import {
    RateCardsData,
} from 'app/requests/RateCard/RateCard.types'
import {
    TypeIcon,
} from 'app/shared-components/NotificationIcon/notificationIcon.types'
import {
    FieldInCard, NestedField,
} from 'app/types/form.types'

import {
    getDeliveryOptions, getValue,
} from 'app/Apps/AccountManagement/AccountLanes/AccountLanes.utils'
import TooltipContentDeliveryService
    from '../AccountLaneTooltipContent/TooltipContentDeliveryService'
import {
    AccountLaneFormFields,
} from '../AccountLaneForm.fields'
import getTransportModeFields from './transportMode.fields'

export default ({
    disabled,
    getAllowedValues,
    logisticDetails,
    isDeliveryRoad,
    handoverPointCountry,
    showLTL,
    showFTL,
    isStatusPriced,
}: {
    disabled?: boolean,
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
    logisticDetails?: RateCardsData,
    isDeliveryRoad?: boolean,
    handoverPointCountry: WithId<number>,
    showFTL?: boolean,
    showLTL?: boolean,
    isStatusPriced?: boolean,
}): FieldInCard<keyof AccountLaneFormFields>[] => {
    const deliveryOptions = getDeliveryOptions({
        originPositioningFtl: logisticDetails?.originPositioningFtl,
        originPositioningLtl: logisticDetails?.originPositioningLtl,
    })

    return [
        {
            id: 'column1',
            fields: [
                {
                    name: 'deliveryServiceType',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(deliveryOptions),
                    labelKey: 'AccountLane.deliveryServiceType',
                    notificationIconProps: {
                        content: TooltipContentDeliveryService,
                        type: TypeIcon.INFO,
                    },
                    required: true,
                    useDropdown: true,
                    defaultValue: Object.keys(deliveryOptions)?.length === 1
                        ? Object.keys(deliveryOptions)[0] : undefined,
                    disabled: disabled || isStatusPriced,
                },
                {
                    name: 'originPositioningFtl',
                    componentName: 'InputSingleline',
                    value: getValue(logisticDetails?.originPositioningFtl),
                    disabled: true,
                    className: logisticDetails?.originPositioningFtl && 'green',
                    labelKey: 'AccountQuotes.originDeliveryFTL',
                },
                {
                    name: 'originTruckCapacity',
                    componentName: 'InputSingleline',
                    value: logisticDetails?.originTruckCapacity,
                    disabled: true,
                    labelKey: 'AccountQuotes.palletsPerTruck',
                },
                {
                    name: 'originPositioningLtl',
                    componentName: 'InputSingleline',
                    value: getValue(logisticDetails?.originPositioningLtl),
                    disabled: true,
                    className: logisticDetails?.originPositioningLtl && 'green',
                    labelKey: 'AccountQuotes.originDeliveryLTL',
                },
                ...(isDeliveryRoad
                    ? getTransportModeFields({
                        getAllowedValues,
                        disabled,
                        showFTL,
                        showLTL,
                    })
                    : []) as NestedField<keyof AccountLaneFormFields>[],
            ],
        },
        {
            id: 'column2',
            fields: [
                ...(isDeliveryRoad ? [
                    {
                        name: 'handoverPointCountry',
                        componentName: 'CountryDataSelector',
                        labelKey: 'AccountLane.handoverPointCountry',
                        required: true,
                        disabled: disabled || isStatusPriced,
                    },
                    {
                        name: 'handoverPointZipCode',
                        componentName: 'ZipCodeInput',
                        labelKey: 'AccountLane.handoverPointZipCode',
                        required: true,
                        country: handoverPointCountry,
                        disabled: disabled || isStatusPriced,
                    },
                    {
                        name: 'handoverPointAddress',
                        componentName: 'InputSingleline',
                        labelKey: 'AccountLane.handoverPointAddress',
                        disabled,
                    },
                ] as NestedField<keyof AccountLaneFormFields>[] : []),
                {
                    name: 'handoverPointContacts',
                    componentName: 'MultipleContactObjectSelector',
                    labelKey: 'AccountLane.handoverPointContacts',
                    disabled,
                },
            ],
        },
    ]
}
